/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiation-dosimetry.reducer';

export const RadiationDosimetryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiationDosimetryEntity = useAppSelector(state => state.radiationDosimetry.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiationDosimetryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiationDosimetry.detail.title">RadiationDosimetry</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.name">Name</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.description">Description</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.description}</dd>
          <dt>
            <span id="doseDistribution">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.doseDistribution">Dose Distribution</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.doseDistribution}</dd>
          <dt>
            <span id="doseCalculationAlgorithm">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.doseCalculationAlgorithm">Dose Calculation Algorithm</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.doseCalculationAlgorithm}</dd>
          <dt>
            <span id="doseGrid">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.doseGrid">Dose Grid</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.doseGrid}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.radiationDosimetry.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{radiationDosimetryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationDosimetry.radiationType">Radiation Type</Translate>
          </dt>
          <dd>
            {radiationDosimetryEntity.radiationTypes
              ? radiationDosimetryEntity.radiationTypes.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {radiationDosimetryEntity.radiationTypes && i === radiationDosimetryEntity.radiationTypes.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/radiation-dosimetry" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiation-dosimetry/${radiationDosimetryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiationDosimetryDetail;
